import { useStaticQuery, graphql } from "gatsby";

export default function useWhatsOn() {
  const data = useStaticQuery(graphql`
    query MyQuery {
      wpPage(id: { eq: "cG9zdDoxMzk2" }) {
        title
        whatsOnPageOptions {
          rotatingBadgeText
          showWhatsOnLinkInMenu
          showWhatsOnRotatingBadge
        }
      }
    }
  `);

  return data.wpPage;
}
